export default __webpack_public_path__ + "static/media/056.a0d0b873.svg";